// ProductEditPopup.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './ProductEditPopup.css';
import { updateProduct, updateWoocommerceProduct } from '../../../Action/productAction';
import { createAuditHistory } from '../../../Action/auditHistoryAction';

function ProductEditPopup({ product, onClose, onSave, currentUser }) {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const [formData, setFormData] = useState({
        product_id: product.product_id,
        name: product.name,
        stock: product.stock,
        price: product.price,
        id: product.id,
        variation_id: product.product_variant_id || null,
        variation_name: product.variation_name || null,
        product_variation: product.variation_id,
        on_sale: product.offerDetails?.on_sale || false,
        regular_price: product.offerDetails?.regular_price || product.price,
        sale_price: product.offerDetails?.sale_price || ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSaleToggle = () => {
        setFormData((prevData) => {
            const newOnSale = !prevData.on_sale;
            return {
                ...prevData,
                on_sale: newOnSale,
                // Adjust prices based on the toggle state
                price: newOnSale ? prevData.sale_price : prevData.regular_price,
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const auditHistory = {
            product_id: product.id || null,
            product_woocom_id: product.product_id,
            product_name: formData.name,
            previous_stock: product.stock,
            updated_stock: formData.stock,
            previous_price: product.price,
            updated_price: formData.price,
            updated_date: new Date().toISOString(),
            ip_address: '192.168.1.1',
            updated_by: user.user.id,
            variant_id: formData.product_variation || null
        };

        try {
            await dispatch(updateWoocommerceProduct(formData));
            await dispatch(updateProduct(formData));
            toast.success('Product updated and saved successfully!');
            await dispatch(createAuditHistory(auditHistory));
            onSave();
            onClose();
        } catch (error) {
            toast.error('Failed to update product.');
            console.error('Error updating product:', error);
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="popup-overlay" onClick={handleOverlayClick}>
            <div className="popup-content">
                <h2>Edit Product</h2>
                <form onSubmit={handleSubmit}>
                    {formData.variation_name && (
                        <div className="form-group">
                            <label>Variation Name</label>
                            <input type="text" name="variation_name" value={formData.variation_name} disabled />
                        </div>
                    )}
                    <div className="form-group">
                        <label>Product Name</label>
                        <input type="text" name="name" value={formData.name || ''} onChange={handleInputChange} required disabled />
                    </div>
                    <div className="form-group">
                        <label>Stock</label>
                        <input type="number" name="stock" value={formData.stock || ''} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group">
                        <label>Price</label>
                        <input type="number" name="price" value={formData.price || ''} onChange={handleInputChange} required />
                    </div>
                    <div className="form-group toggle-group">
                        <label>On Sale</label>
                        <div className="switch">
                            <input
                                type="checkbox"
                                checked={formData.on_sale}
                                onChange={handleSaleToggle}
                                id="onSaleSwitch"
                                disabled={false} // The switch is always interactive now
                            />
                            <label htmlFor="onSaleSwitch" className="switch-label"></label>
                        </div>
                    </div>
                    {formData.on_sale && (
                        <div className="sale-fields">
                            <div className="form-group">
                                <label>Regular Price</label>
                                <input type="number" name="regular_price" value={formData.regular_price || ''} onChange={handleInputChange} required />
                            </div>
                            <div className="form-group">
                                <label>Sale Price</label>
                                <input
                                    type="number"
                                    name="sale_price"
                                    value={formData.sale_price || ''} 
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            sale_price: value,
                                            // If currently on sale, update the displayed price
                                            price: prevData.on_sale ? value : prevData.price
                                        }));
                                    }}
                                    required
                                />
                            </div>
                        </div>
                    )}
                    <div className="form-actions">
                        <button type="submit" className="save-button">Save</button>
                        <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ProductEditPopup;
